import NoItems from '@/components/ui/NoItems.tsx';
import { useDetailsScreen } from '@/features/dashboard/bookingChanges/contexts/DetailsContext.ts';
import useParticipantBillView from '@/features/dashboard/bookingChanges/hooks/useParticipantBillView.ts';
import {
  ParticipantBillView,
  ParticipantBillViewSkeleton,
} from '@/features/dashboard/bookingChanges/components/bill';

/**
 * Zakładka „Informacje” ekranu uczestnika — dane i rachunek jednej osoby.
 * Widok czyta z tego samego zapytania, co szkielet ekranu, więc wejście
 * w zakładkę nie kosztuje ani jednego dodatkowego strzału do backendu.
 */
const ParticipantInfoTab = () => {
  const {
    bookingId,
    bookingCode,
    currentPersonId,
    isEditing,
    onlyChanged,
    onOnlyChangedChange,
    editField,
    onOpenBooking,
  } = useDetailsScreen();

  const { view, isLoading } = useParticipantBillView(
    bookingId,
    currentPersonId,
  );

  if (isLoading) {
    return <ParticipantBillViewSkeleton />;
  }

  if (!view) {
    return (
      <NoItems
        title="Brak rachunku uczestnika"
        description="Ten uczestnik nie ma jeszcze pozycji w rachunku rezerwacji."
      />
    );
  }

  return (
    <ParticipantBillView
      data={view}
      isEditing={isEditing}
      onlyChanged={onlyChanged}
      onOnlyChangedChange={onOnlyChangedChange}
      onRowAction={editField.openRow}
      onAddManualRow={editField.addManualLine}
      onOpenInstallments={onOpenBooking}
      bookingCode={bookingCode}
    />
  );
};

export default ParticipantInfoTab;
